export default {
    state: {
        loadingPosts: false,
        statusOk: null,
        errMessage: "",
        okMessage: "",
        searchingCount: false,
        searchCount: 0,
        total: 0,
        itemsPerPage: 0,
        page: 1,
        items: []
    },
    mutations: {
        'HOME_LOADING_POSTS' (state, val) {
            state.loadingPosts = val;
        },
        'HOME_SEARCHING_COUNT' (state, val) {
            state.searchingCount = val;
        },
        'HOME_SEARCH_COUNT' (state, val) {
            state.searchCount = val.total;
        },
        'HOME_LOADING_POSTS_SUCCESS' (state, val) {
            state.statusOk = true;
            state.total = val.total;
            state.itemsPerPage = val.itemsPerPage;
            state.page = val.page;
            state.items = val.items;
            state.errMessage = "";
        },
        'HOME_LOADING_POSTS_ERROR' (state, val) {
            state.statusOk = false;
            state.errMessage = val;
            state.okMessage = "";
        },
        'HOME_CURRENT_PAGE' (state, val) {
            state.page = val;
        }
    },
    actions: {
        'HOME_FETCH_POSTS' ({commit}, query) {
            /* eslint-disable */
            console.log("query", query);
            query.status = "selling";
            query.sort = "-currentPrice";
            commit('HOME_LOADING_POSTS', true);
            axios.get(`/item`, {
                params: query
            })
            .then(resp => {
                commit('HOME_LOADING_POSTS', false);
                commit('HOME_LOADING_POSTS_SUCCESS', resp.data.response);
                console.log("all posts", resp);
            })
            .catch(err => {
                commit('HOME_LOADING_POSTS', false);
                commit('HOME_LOADING_POSTS_ERROR', 'Error. Server error');
                console.log("all posts err", err);
            });
        },
        'HOME_FETCH_COUNT' ({commit}, query) {
            /* eslint-disable */
            console.log("count query", query);
            query.status = "selling";
            query.searchType = "count";
            commit('HOME_SEARCHING_COUNT', true);
            axios.get(`/item`, {
                params: query
            })
            .then(resp => {
                commit('HOME_SEARCHING_COUNT', false);
                commit('HOME_SEARCH_COUNT', resp.data.response);
                console.log("count posts", resp);
            })
            .catch(err => {
                commit('HOME_SEARCHING_COUNT', false);
                commit('HOME_SEARCH_COUNT', {total: 0});
                console.log("count posts err", err);
            });
        }
    }
};